import { useState } from "react";
import { X, Phone, Video, ArrowRight } from "lucide-react";

export default function JoinMeetingModal({ booking, onClose }) {
  const [method, setMethod] = useState("video");

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl w-full max-w-md p-6">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white text-sm font-bold flex items-center justify-center">
              {booking.initials}
            </div>
            <div>
              <p className="font-bold text-gray-900">{booking.name}</p>
              <p className="text-sm text-gray-500">{booking.specialty}</p>
            </div>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        <p className="text-sm font-semibold text-gray-700 mb-3">How would you like to join?</p>

        <div className="space-y-3 mb-6">
          <button
            type="button"
            onClick={() => setMethod("call")}
            className={`w-full flex items-center gap-4 border rounded-xl px-4 py-3.5 text-left transition ${
              method === "call" ? "border-indigo-500 bg-indigo-50" : "border-gray-200 hover:border-indigo-300"
            }`}
          >
            <div className="w-9 h-9 rounded-lg bg-gray-100 flex items-center justify-center shrink-0">
              <Phone className="w-4 h-4 text-gray-600" />
            </div>
            <div className="flex-1">
              <p className="font-semibold text-gray-900 text-sm">Direct Call</p>
              <p className="text-xs text-gray-500">Connect over a regular voice call</p>
            </div>
            <span
              className={`w-4 h-4 rounded-full border-2 shrink-0 ${
                method === "call" ? "border-indigo-600 bg-indigo-600" : "border-gray-300"
              }`}
            />
          </button>

          <button
            type="button"
            onClick={() => setMethod("video")}
            className={`w-full flex items-center gap-4 border rounded-xl px-4 py-3.5 text-left transition ${
              method === "video" ? "border-indigo-500 bg-indigo-50" : "border-gray-200 hover:border-indigo-300"
            }`}
          >
            <div className="w-9 h-9 rounded-lg bg-gray-100 flex items-center justify-center shrink-0">
              <Video className="w-4 h-4 text-gray-600" />
            </div>
            <div className="flex-1">
              <p className="font-semibold text-gray-900 text-sm">Video Conference</p>
              <p className="text-xs text-gray-500">Join a face-to-face video session</p>
            </div>
            <span
              className={`w-4 h-4 rounded-full border-2 shrink-0 ${
                method === "video" ? "border-indigo-600 bg-indigo-600" : "border-gray-300"
              }`}
            />
          </button>
        </div>

        <button
          type="button"
          onClick={onClose}
          className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-500 to-purple-500 text-white font-semibold py-3 rounded-xl hover:opacity-90 transition"
        >
          Join now <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}